import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Application from '@/components/Application'
import Examine from '@/components/Examine'
import Nopay from '@/components/Nopay'
import Paysuc from '@/components/Paysuc'
import Serverclaim from '@/components/Serverclaim'
import History from '@/components/History'
import Detail from '@/components/Detail'

Vue.use(Router)

export default new Router({
  // mode:"history",
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Application.html',
      name: 'Application',
      component: Application
    },
    {
      path: '/Examine.html',
      name: 'Examine',
      component: Examine
    },
    {
      path: '/Nopay.html',
      name: 'Nopay',
      component: Nopay
    },
    {
      path: '/Paysuc.html',
      name: 'Paysuc',
      component: Paysuc
    },
    {
      path: '/Serverclaim.html',
      name: 'Serverclaim',
      component: Serverclaim
    },
    {
      path: '/History.html',
      name: 'History',
      component: History
    },
    {
      path: '/Detail.html',
      name: 'Detail',
      component: Detail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js